import React from 'react';
import { Card, CardActions, CardHeader, CardMedia, CardContent, Typography, Avatar } from '@mui/material';

// Images
import imageDashboard from './../assets/images/fondo-admin-dash.jpg';
import userPhoto from './../assets/images/user-admin.png';

export default () => (
    <Card style={{ margin: '2em' }}>
        <CardHeader
            title="Daniel Penagos Calvete"
            subheader="Administrador"
            avatar={<Avatar src={userPhoto} />}
        />
        <CardMedia>
            <img src={imageDashboard} alt="Dashboard" style={{ width: '100%' }} /> 
        </CardMedia>
        <CardContent>
            <Typography>
                Bienvenido al panel de administración de Loticolombia
            </Typography>
        </CardContent>
    </Card>
);
